import styled from 'styled-components';

export const BannerHeader = styled.div`
  width: 100%;
  height: 277px;
  background: ${({ bgImage }) => `url('${bgImage}') no-repeat center;`};
  background-size: cover;
`;
